import { render, staticRenderFns } from "./zeroorder.vue?vue&type=template&id=47d57f78&scoped=true"
import script from "./zeroorder.vue?vue&type=script&lang=js"
export * from "./zeroorder.vue?vue&type=script&lang=js"
import style0 from "./zeroorder.vue?vue&type=style&index=0&id=47d57f78&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d57f78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d57f78')) {
      api.createRecord('47d57f78', component.options)
    } else {
      api.reload('47d57f78', component.options)
    }
    module.hot.accept("./zeroorder.vue?vue&type=template&id=47d57f78&scoped=true", function () {
      api.rerender('47d57f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sale/zeroorder.vue"
export default component.exports